import { useContext, useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router';

import Datatable from '../../../Components/Datatable/Datatable';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler } from '../../../Utils/Helpers';
import { SportRuleContext } from '../Context/SportRuleContext';

const Rank = () => {
  const context = useContext(SportRuleContext);
  const { get } = useApi();
  const navigate = useNavigate();
  const { error } = useToast();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [serverErrors, setServerErrors] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalRemoveObject, setModalRemoveObject] = useState(undefined);
  const [formSubmitLoaing, setFormSubmitLoaing] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getRanks();
    };
    getData();
  }, [search]);

  const getRanks = async () => {
    setLoading(true);
    await get(
      `/sport-rule/rank${search}`,
      (res) => {
        context.ranks = res;
        setLoading(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
        setLoading(false);
      },
    );
  };

  const showRankCard = async (item) => {
    await get(
      `/competition/${item?.competition?.id}/user/rank?sport_id=${
        item?.sport?.id
      }&national_card_id=${item?.user?.national_card_id}&type=${
        item?.user != null && item?.team == null && item?.league == null
          ? 1
          : item?.team != null
          ? 2
          : item?.league != null
          ? 3
          : null
      }`,
      (res) => {
        if (res.error) {
          setFormSubmitLoaing(false);
          return error(res?.message);
        }
        setFormSubmitLoaing(false);

        return navigate(`/id-card/competition/${item?.competition?.id}/rank`, {
          state: {
            user: res?.data,
            sport: res?.data?.sport,
            weight: res?.data?.weight,
            type:
              item?.user != null
                ? 1
                : item?.team != null
                ? 2
                : item?.league != null
                ? 3
                : null,
          },
        });
      },
      (err) => {
        setFormSubmitLoaing(false);
        if (err?.status === 422 || err.status === 400) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error('دریافت اطلاعات با خطا روبرو شد.');
        }
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <>
      <Master>
        <TitleBar title='حکم های قهرمانی کشور' showCreateBtn={false} />
        <Datatable
          data={context.ranks?.data}
          disableAllActions={true}
          editUrl='/sport-rule/rank'
          meta={context.ranks?.meta}
          search={search}
          setModalIsOpen={setModalIsOpen}
          setModalRemoveObject={setModalRemoveObject}
          basePagePath={`/sport-rule`}
          showCountRecourd={false}
          columns={['نام مسابقه', 'رشته', 'وزن', 'مقام', 'نمایش حکم']}
          rows={[
            { name: 'competition.title', type: 'relation', relType: 'string' },
            { name: 'sport.title', type: 'relation', relType: 'string' },
            { name: 'weight.weight', type: 'relation', relType: 'string' },
            { name: 'rank_title', type: 'string' },
            {
              type: 'action',
              action: showRankCard,
            },
          ]}
        />
      </Master>
    </>
  );
};

export default Rank;
